import { RECEIVE_ASSETS } from '../actions/AssetsAction'

const defaultItems = {
    logo        : null,
    strapline   : null,
    filters     : [],
    links       : [],
    theme       : null,
    pin         : null,
    userLocation: null
};

const defaultState = {
    fetched      : false,
    isFetching   : false,
    didInvalidate: false,
    items        : defaultItems
};

const assets = (state = defaultState, action) => {
    let newState;
    switch (action.type)
    {
        case RECEIVE_ASSETS:
            newState = {...state,
                isFetching   : false,
                fetched      : true,
                didInvalidate: false,
                items        : { 
                    logo        : action.payload.assets.logo,
                    footerLogos : action.payload.assets.footerLogos,
                    strapline   : action.payload.assets.strapline,
                    links       : action.payload.links,
                    theme       : action.payload.theme,
                    pin         : action.payload.assets.pin,
                    userLocation: action.payload.assets.userLocation
                },
                lastUpdated  : action.receivedAt
            };
            break;
        default:
            newState = state;
            break;
    }

    return newState;
};

export default assets;


// WEBPACK FOOTER //
// ./src/reducers/AssetsReducer.js